import { useLayoutEffect, useRef } from 'react';

import { BREAKPOINTS } from '@libs/common-next';

import { useHeaderLayoutStore } from '../../shared';

const MENU_POINTER_MEDIA_QUERY = '(hover: hover) and (pointer: fine)';

export function useHeaderMainSection() {
    const containerRef = useRef<HTMLDivElement>(null);
    const setIsDesktopMenu = useHeaderLayoutStore(state => state.setIsDesktopMenu);

    useLayoutEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const mediaQuery = window.matchMedia(MENU_POINTER_MEDIA_QUERY);
        let containerWidth = 0;

        const update = () => setIsDesktopMenu(containerWidth >= BREAKPOINTS.xl && mediaQuery.matches);
        const observer = new ResizeObserver(([entry]) => {
            containerWidth = entry.contentRect.width;
            update();
        });

        // The observer also reports the initial content-box width.
        observer.observe(container);
        mediaQuery.addEventListener('change', update);

        return () => {
            observer.disconnect();
            mediaQuery.removeEventListener('change', update);
            setIsDesktopMenu(false);
        };
    }, [setIsDesktopMenu]);

    return containerRef;
}
